import { render, staticRenderFns } from "./RefreshPage.vue?vue&type=template&id=afda0bd2&scoped=true&"
import script from "./RefreshPage.vue?vue&type=script&lang=js&"
export * from "./RefreshPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "afda0bd2",
  null
  
)

export default component.exports